module.exports = __webpack_public_path__ + "static/media/flowChart.998b3caf.svg";